module.exports = __webpack_public_path__ + "img/36exp.a2bb7534.jpg";